import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  Fragment,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import {
  Grid,
  Button,
  TextField,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withStyles } from "@material-ui/core/styles";

import Context from "context/context";
import UnlockShiptoManagementAPI from "apis/UnlockShiptoManagement/UnlockShiptoManagement";
import { styles } from "./styles";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": { color: "#D3D3D3" },
    "& .MuiFormLabel-root": { color: "#707070" },
    "& .MuiInputBase-input": { color: "#707070" },
    "& .MuiInput-underline:before": { borderBottomColor: "#707070!important" },
    "& .MuiInput-underline:after": { borderBottomColor: "#707070!important" },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#707070" },
      "&:hover fieldset": { borderColor: "#707070" },
      "&.Mui-focused fieldset": { borderColor: "#707070" },
      borderRadius: 20,
    },
  },
})(TextField);

export default function EditShiptoPage() {
  const { dispatch } = useContext(Context);
  const { updateShiptoStatus } = UnlockShiptoManagementAPI();

  const history = useHistory();
  const location = useLocation();
  const classes = styles();

  const [states, setstates] = useState({
    shipto: "",
    reviewStatus: "Eligible",
    data: {},
    editedData: {},
    isEdit: false,
    loading: false,
  });

  const { shipto, reviewStatus, data, editedData, isEdit, loading } = states;

  const setStates = useCallback((newState) => {
    setstates((prev) => ({ ...prev, ...newState }));
  }, []);

  const setDataObj = useCallback(
    (dataObj) => {
      setStates({
        data: dataObj,
        shipto: dataObj?.customer_account_number,
        reviewStatus: dataObj?.review_status || "Eligible",
      });
    },
    [setStates]
  );

  useEffect(() => {
    if (location?.state?.data) {
      setDataObj(location.state.data);
    } else {
      toast.error("No data found. Please navigate from list page.");
      history.goBack();
    }
  }, [location, setDataObj, history]);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "SHIPTO", "EDIT"],
    });
  }, [dispatch]);

  const handleUpdate = async () => {
    try {
      if (Object.keys(editedData).length === 0) {
        toast.error("Please change at least one field.");
        return;
      }

      setStates({ loading: true });

      const payload = {
        customer_account_number: data?.customer_account_number,
        review_status: reviewStatus,
        status: reviewStatus === "Inactive" ? false : true,
      };

      const res = await updateShiptoStatus(payload);

      if (res?.success === true || res?.data?.success === true) {
        toast.success("Updated successfully!");
        history.goBack();
      } else {
        toast.error(res?.message || "Update failed.");
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong.");
    } finally {
      setStates({ loading: false });
    }
  };

  return (
    <Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton onClick={() => history.goBack()}>
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>

          {!isEdit && (
            <Button
              className={`${classes.createBtn1} dash-1-filter-btn`}
              onClick={() => setStates({ isEdit: true })}
            >
              Edit
            </Button>
          )}
        </Grid>
      </Grid>

      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                Customer Account Number :
              </strong>
            </Grid>
            <Grid item xs={8}>
              <span className={classes.label}>{shipto}</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <strong className={classes.label}>Review Status :</strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  value={reviewStatus}
                  onChange={(e) => {
                    const value = e.target.value;
                    setStates({
                      reviewStatus: value,
                      editedData: { ...editedData, reviewStatus: value },
                    });
                  }}
                >
                  <MenuItem value="Eligible">Eligible</MenuItem>
                  <MenuItem value="Ineligible">Ineligible</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="Hard Ineligible">Hard Ineligible</MenuItem>
                </CssTextField>
              ) : (
                <span className={classes.label}>{reviewStatus}</span>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {isEdit && (
        <Grid container spacing={0} style={{ padding: 10 }}>
          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button
              className={classes.cancelBtn}
              onClick={() => {
                setDataObj(data);
                setStates({ isEdit: false, editedData: {} });
              }}
            >
              Cancel
            </Button>

            &nbsp;&nbsp;&nbsp;

            <Button
              className={classes.submitBtn}
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </Button>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}